export default __webpack_public_path__ + "static/media/MI_Beampath.87740705.gif";